import React, { Fragment } from 'react';
import { differenceInDays } from 'date-fns';

import Done from './Done';
import Start from './Start';

import { makePersistId } from './utils';

type Props = {
  appId: ID;
  isMigrated: boolean;
  migrationDate?: number;
  wasConvertedFromWB?: boolean;
};

function CTAConversionMigration(props: Props) {
  const { appId, isMigrated, migrationDate, wasConvertedFromWB } = props;

  const shouldRenderStartCTA = wasConvertedFromWB && !isMigrated;

  const shouldRenderDoneCTA =
    wasConvertedFromWB &&
    isMigrated &&
    migrationDate &&
    differenceInDays(Date.now(), migrationDate) <= 60;

  return (
    <Fragment>
      {shouldRenderStartCTA && <Start />}
      {shouldRenderDoneCTA && <Done persistId={makePersistId(appId)} />}
    </Fragment>
  );
}

export default CTAConversionMigration;
